/** TEMPORARY allowlist: the ATT soluto Guided Browsing profiles validating the ATT behavior set. They get Call Focus
 *  in the profile engine and are scored by the `session/{sessionId}/evaluate` endpoint in Expert University. Remove
 *  once both open to all ATT soluto profiles. */
const ATT_GUIDED_BROWSING_PROFILE_IDS: ReadonlySet<string> = new Set(["cierra_dennis", "mason_lutterman"]);

/** Profile ids are only unique within a partner, so the partner is part of the match. */
export function isAttGuidedBrowsingProfile(partner: string | undefined, profileId: string | undefined): boolean {
    return partner === "att" && profileId != null && ATT_GUIDED_BROWSING_PROFILE_IDS.has(profileId);
}
